import React from 'react';
import { OrderContactInfo } from '../types';
import { useTranslation } from '../i18n';
import { ContactDetails } from './ContactDetails';

export const OwnerContactPreview: React.FC<{ contact: OrderContactInfo }> = ({ contact }) => {
  const { t } = useTranslation();

  return (
    <div
      className="contact-preview"
      style={{
        marginTop: '1rem',
        padding: '0.75rem',
        border: '1px solid var(--color-border, #ddd)',
        borderRadius: '6px',
        background: 'var(--color-surface, #fafafa)',
      }}
    >
      <ContactDetails
        title={t('rental_response.contact_preview_label')}
        contact={contact}
        showAddresses
      />
    </div>
  );
};
